// extracted by mini-css-extract-plugin
export default {"HeroImg":"HeroImg_HeroImg__EWXwZ","mainImg":"HeroImg_mainImg__JXVaE"};